// import React from "react";
// import { BrowserRouter, Routes, Route, useNavigate } from "react-router-dom";
// import "./App.css";
// import "./Dashboard.css";

// import LoginPage from "./components/shared/auth/LoginPage.js";
// import RequireAuth from "./components/shared/auth/RequireAuth.js";
// import DashboardLayout from "./components/shared/layout/DashboardLayout.js";
// import AppDialogHost from "./components/shared/dialogs/AppDialogHost.js";

// function AppRoutes() {
//   const navigate = useNavigate();

//   const handleLoginSuccess = (token, role) => {
//     localStorage.setItem("als_token", token);
//     localStorage.setItem("als_role", role);
//     navigate("/dashboard");
//   };

//   const handleLogout = () => {
//     localStorage.removeItem("als_token");
//     localStorage.removeItem("als_role");
//     navigate("/login");
//   };

//   return (
//     <Routes>
//       <Route
//         path="/login"
//         element={<LoginPage onLoginSuccess={handleLoginSuccess} />}
//       />
//       <Route element={<RequireAuth />}>
//         <Route
//           path="/*"
//           element={<DashboardLayout onLogout={handleLogout} />}
//         />
//       </Route>
//     </Routes>
//   );
// }

// function App() {
//   return (
//     <BrowserRouter>
//       <AppRoutes />
//       <AppDialogHost />
//     </BrowserRouter>

// );
// }

// export default App;








import React from "react";
import { BrowserRouter, Routes, Route, useNavigate } from "react-router-dom";
import "./App.css";
import "./Dashboard.css";

import LoginPage from "./components/shared/auth/LoginPage.js";
import RequireAuth from "./components/shared/auth/RequireAuth.js";
import DashboardLayout from "./components/shared/layout/DashboardLayout.js";
import AppDialogHost from "./components/shared/dialogs/AppDialogHost.js";

function AppRoutes() {
  const navigate = useNavigate();

  const handleLoginSuccess = (token, role) => {
    const normalizedRole = (role || "").toLowerCase();
    const cleanToken = String(token || "").trim();
    localStorage.setItem("als_token", cleanToken);
    localStorage.setItem("als_role", normalizedRole);
    // Teachers go to their portal — the admin dashboard fetches campuses and
    // can clear the session on 401, which looked like instant logout.
    if (normalizedRole === "teacher") {
      navigate("/teacher/overview");
      return;
    }
    if (normalizedRole === "parent") {
      navigate("/parent/overview");
      return;
    }
    navigate("/dashboard");
  };

  const handleLogout = () => {
    localStorage.removeItem("als_token");
    localStorage.removeItem("als_role");
    localStorage.removeItem("als_teacher_id");
    localStorage.removeItem("als_teacher_name");
    localStorage.removeItem("als_teacher_campus_id");
    localStorage.removeItem("als_teacher_email");
    localStorage.removeItem("als_teacher_subject");
    localStorage.removeItem("als_teacher_employee_id");
    localStorage.removeItem("als_parent_name");
    localStorage.removeItem("als_parent_id");
    sessionStorage.removeItem("als_parent_active_child_id");
    localStorage.removeItem("als_user_name");
    navigate("/login");
  };

  return (
    <Routes>
      <Route
        path="/login"
        element={<LoginPage onLoginSuccess={handleLoginSuccess} />}
      />
      <Route element={<RequireAuth />}>
        <Route
          path="/*"
          element={<DashboardLayout onLogout={handleLogout} />}
        />
      </Route>
    </Routes>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AppRoutes />
      <AppDialogHost />
    </BrowserRouter>

  );
}

export default App;
